import {NgModule} from '@angular/core';
import {SendungsketteComponent} from './sendungskette.component';
import {AgGridModule} from 'ag-grid-angular';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { EmpfaengerdetailsComponent } from './empfaengerdetails/empfaengerdetails.component';

@NgModule({
  declarations: [SendungsketteComponent, EmpfaengerdetailsComponent],
    imports: [
        CollapseModule,
        AgGridModule,
        FontAwesomeModule
    ],
  entryComponents: [EmpfaengerdetailsComponent],
  exports: [SendungsketteComponent]
})
export class SendungsketteModule {
}
